/**
 *  @class
 *  @function FeaturedSlider
 *  Horizontal carousel with center pop-out and infinite loop
 */
if (!customElements.get('featured-slider')) {
  class FeaturedSlider extends HTMLElement {
    connectedCallback() {
      this.track       = this.querySelector('.featured-slider__track');
      this.originalSlides = Array.from(this.track.querySelectorAll('.featured-slider__slide'));
      this.dotsContainer  = this.querySelector('.featured-slider__dots');
      this.prevBtn     = this.querySelector('.featured-slider__arrow--prev');
      this.nextBtn     = this.querySelector('.featured-slider__arrow--next');
      this.total       = this.originalSlides.length;
      this.current     = 0;
      this.locked      = false;
      this.timer       = null;
      this._unlockTimer = null;

      this.autoplay  = this.hasAttribute('autoplay');
      this.interval  = parseInt(this.getAttribute('interval')) || 3000;

      if (this.total <= 3) {
        this.track.classList.add('featured-slider__track--static');
        this.markCenterStatic();
        return;
      }

      this.cloneCount = 2;
      this.setupClones();
      this.slides     = Array.from(this.track.querySelectorAll('.featured-slider__slide'));
      this.trackIndex = this.current + this.cloneCount;

      this.createDots();
      this.positionTrack(false);
      this.updateClasses();
      this.updateDots();
      this.addEvents();

      if (this.autoplay) this.startAutoplay();
    }

    markCenterStatic() {
      this.originalSlides[Math.floor(this.total / 2)].classList.add('active');
    }

    setupClones() {
      var frag = document.createDocumentFragment();
      for (var i = this.total - this.cloneCount; i < this.total; i++) {
        var c = this.originalSlides[i].cloneNode(true);
        c.classList.add('featured-slider__slide--clone');
        c.removeAttribute('id');
        frag.appendChild(c);
      }
      this.track.insertBefore(frag, this.track.firstChild);

      for (var i = 0; i < this.cloneCount; i++) {
        var c = this.originalSlides[i].cloneNode(true);
        c.classList.add('featured-slider__slide--clone');
        c.removeAttribute('id');
        this.track.appendChild(c);
      }
    }

    getTranslateX() {
      var target        = this.slides[this.trackIndex];
      var containerWidth = this.offsetWidth;
      var slideWidth    = target.offsetWidth;
      return -(target.offsetLeft - (containerWidth - slideWidth) / 2);
    }

    positionTrack(animate) {
      this.track.style.transition = animate ? 'transform 0.45s ease' : 'none';
      // Force reflow so 'none' is applied before we set the value (critical for Safari)
      if (!animate) this.track.getBoundingClientRect();
      this.track.style.transform = 'translateX(' + this.getTranslateX() + 'px)';
    }

    updateClasses() {
      this.slides.forEach(function(s) { s.classList.remove('active'); });
      this.slides[this.trackIndex].classList.add('active');
    }

    updateDots() {
      if (!this.dotsContainer) return;
      var cur = this.current;
      Array.from(this.dotsContainer.children).forEach(function(d, i) {
        d.classList.toggle('active', i === cur);
      });
    }

    // Single method that handles all movement — prevents any double-call possibility
    moveTo(newTrackIndex, newCurrent) {
      if (this.locked) return;
      this.locked = true;

      // Clear any previous safety timer
      clearTimeout(this._unlockTimer);

      this.trackIndex = newTrackIndex;
      this.current    = newCurrent;
      this.positionTrack(true);
      this.updateClasses();
      this.updateDots();

      // Safety unlock: if transitionend doesn't fire (Safari bug), unlock after 500ms
      this._unlockTimer = setTimeout(function() {
        this._finishMove();
      }.bind(this), 500);
    }

    _finishMove() {
      clearTimeout(this._unlockTimer);
      this.locked = false;

      // Infinite loop jump: silently reposition to real slide if we're on a clone
      var needsJump = this.trackIndex < this.cloneCount ||
                      this.trackIndex >= this.cloneCount + this.total;
      if (needsJump) {
        this.trackIndex += (this.trackIndex < this.cloneCount) ? this.total : -this.total;
        this.positionTrack(false);
        this.updateClasses();
      }
    }

    next() {
      var newTrack   = this.trackIndex + 1;
      var newCurrent = (this.current + 1) % this.total;
      this.moveTo(newTrack, newCurrent);
    }

    prev() {
      var newTrack   = this.trackIndex - 1;
      var newCurrent = (this.current - 1 + this.total) % this.total;
      this.moveTo(newTrack, newCurrent);
    }

    goToDot(realIndex) {
      if (this.locked || realIndex === this.current) return;
      this.moveTo(realIndex + this.cloneCount, realIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(function() { this.next(); }.bind(this), this.interval);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    createDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      for (var i = 0; i < this.total; i++) {
        var dot = document.createElement('button');
        dot.className = 'featured-slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function(idx) {
          this.goToDot(idx);
          if (this.autoplay) this.startAutoplay();
        }.bind(this, i));
        this.dotsContainer.appendChild(dot);
      }
    }

    addEvents() {
      // transitionend — primary unlock path
      this.track.addEventListener('transitionend', function(e) {
        if (e.target === this.track && e.propertyName === 'transform') {
          this._finishMove();
        }
      }.bind(this));

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function() {
          this.prev();
          if (this.autoplay) this.startAutoplay();
        }.bind(this));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function() {
          this.next();
          if (this.autoplay) this.startAutoplay();
        }.bind(this));
      }

      this.querySelectorAll('img').forEach(function(img) {
        img.draggable = false;
        img.addEventListener('dragstart', function(e) { e.preventDefault(); });
      });

      // Swipe — strictly touch-only on touch devices, pointer-only on desktop
      // Prevents the double-fire bug on Safari iOS
      var self      = this;
      var startX    = 0;
      var startY    = 0;
      var swiping   = false;
      var swipeDone = false; // guard: only fire once per gesture

      var isTouchDevice = ('ontouchstart' in window);

      if (isTouchDevice) {
        this.track.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) return;
          startX    = e.touches[0].clientX;
          startY    = e.touches[0].clientY;
          swiping   = true;
          swipeDone = false;
        }, { passive: true });

        this.track.addEventListener('touchmove', function(e) {
          if (!swiping || swipeDone || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;

          // If scrolling vertically more than horizontally, abort swipe
          if (Math.abs(dy) > Math.abs(dx)) { swiping = false; return; }

          if (Math.abs(dx) > 40) {
            swipeDone = true;
            swiping   = false;
            dx < 0 ? self.next() : self.prev();
            if (self.autoplay) self.startAutoplay();
          }
        }, { passive: true });

        this.track.addEventListener('touchend', function() {
          swiping   = false;
          swipeDone = false;
        });

      } else {
        var pointerDown = false;

        this.track.addEventListener('pointerdown', function(e) {
          startX      = e.clientX;
          pointerDown = true;
          swipeDone   = false;
        });

        window.addEventListener('pointermove', function(e) {
          if (!pointerDown || swipeDone) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 40) {
            swipeDone   = true;
            pointerDown = false;
            dx < 0 ? self.next() : self.prev();
            if (self.autoplay) self.startAutoplay();
          }
        });

        window.addEventListener('pointerup', function() {
          pointerDown = false;
          swipeDone   = false;
        });
      }

      window.addEventListener('resize', function() {
        this.positionTrack(false);
      }.bind(this));
    }
  }

  customElements.define('featured-slider', FeaturedSlider);
}